var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-width"},[_c('datatable',{attrs:{"title":"Recruiter Fees","response":_vm.data,"fields":_vm.fields,"show_edit":false,"is_createable":false,"show_operations":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }